import { useNewSidebarExperience } from "featureFlags/hooks/useNewSidebarExperience";

import DirectorySearchPanel from "components/LeftSidebarV2/DirectorySearchPanel/DirectorySearchPanel";
import { Search as BaseSearch } from "components/Search/Search";

type Props = {
  onChange: (val: string) => void;
  value: string;
  autoFocus?: boolean;
  noBorder?: boolean;
  size?: "mini" | "small" | "regular";
  placeholder?: string;
  testId?: string;
  className?: string;
  disabled?: boolean;
  autoComplete?: string;
  controls?: React.ReactNode;
  isLoading?: boolean;
};

export const Search = (props: Props) => {
  const { onChange, value, disabled, controls, isLoading, testId } = props;

  const newSidebarExperience = useNewSidebarExperience();

  if (newSidebarExperience) {
    return (
      <DirectorySearchPanel
        onSearch={onChange}
        search={value}
        controls={controls}
        isLoading={isLoading}
        disabled={disabled}
        testId={testId}
      />
    );
  }
  return <BaseSearch {...props} />;
};
